import { useParams } from "react-router-dom";
import { Page, TopBar } from "@/components/kit";
import DOCS from "@/lib/legal.json";

export default function Legal() {
  const { doc } = useParams();
  const d = DOCS[doc] ?? DOCS.privacy;
  return (
    <Page>
      <TopBar title={d.title} standalone />
      <article className="max-w-3xl mx-auto mt-2 space-y-4" data-testid={`legal-${doc}`}>
        {d.body.map((b, i) => (
          <section key={i}>
            {b.h && <h2 className="text-[17px] font-bold mb-1">{b.h}</h2>}
            <p className="text-[15px] leading-relaxed text-[#334155] whitespace-pre-line">{b.p}</p>
          </section>
        ))}
      </article>
    </Page>
  );
}
